import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Switch, Select, MenuItem, TextField } from "@material-ui/core";
import { ItemFilters } from "./ItemFilters";
import { traerConfiguracionPorCategoria } from "../../actions/configuraciones/ConfiguracionCategoria";
import { useHistory, useLocation } from "react-router";
import moment from "moment";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { SEXO } from "../../utils/constants";
import { areas } from "../../helpers/areas";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  TypographyRoot: {
    marginRight: 10,
  },
  switchBase: {
    color: "#bdbdbd",
    "&$checked": {
      transform: "translateX(16px)",
      color: "#4CAF50",
      "& + $track": {
        backgroundColor: "#3E8040",
        opacity: 1,
        border: "none",
      },
    },
  },
  switchBase2: {
    color: "#bdbdbd",
    "&$checked": {
      transform: "translateX(16px)",
      color: "#ffee58",
      "& + $track": {
        backgroundColor: "#B7A931",
        opacity: 1,
        border: "none",
      },
    },
  },
  checked: {},
  track: {},
  swithColorPrimary: {
    color: "yellow",
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function FiltrosModalConsultas({
  abrirModal,
  setAbrirModal,
  seccionales,
  provincias,
  allLocalidades,
  localidades,
  setLocalidades,
  ...props
}) {
  const classes = useStyles();
  const query = useQuery();
  const history = useHistory();
  const dispatch = useDispatch();

  const [provinciasSelected, setprovinciasSelected] = useState(
    query.get("provincias") ? query.get("provincias").split(",") : []
  );
  const [localidadesSelected, setlocalidadesSelected] = useState(
    query.get("localidades") ? query.get("localidades").split(",") : []
  );
  const [seccionalesSelected, setseccionalesSelected] = useState(
    query.get("seccionales") ? query.get("seccionales").split(",") : []
  );
  const [edadDesde, setEdadDesde] = useState(
    query.get("fecNacDesde") ? moment(query.get("fecNacDesde")) : null
  );
  const [edadHasta, setEdadHasta] = useState(
    query.get("fecNacHasta") ? moment(query.get("fecNacHasta")) : null
  );
  const [fechaDesde, setFechaDesde] = useState(
    query.get("fecAltaDesde") ? moment(query.get("fecAltaDesde")) : null
  );
  const [fechaHasta, setFechaHasta] = useState(
    query.get("fecAltaHasta") ? moment(query.get("fecAltaHasta")) : null
  );
  const [fechaBajaDesde, setFechaBajaDesde] = useState(
    query.get("fecBajaDesde") ? moment(query.get("fecBajaDesde")) : null
  );
  const [fechaBajaHasta, setFechaBajaHasta] = useState(
    query.get("fecBajaHasta") ? moment(query.get("fecBajaHasta")) : null
  );
  const [parentescos, setParentescos] = useState(
    query.get("parentescos") ? true : false
  );
  const [motivoDeBaja, setMotivoBaja] = useState(
    query.get("motivoBaja") ? query.get("motivoBaja") : null
  );
  const [categoria, setCategoria] = useState(
    query.get("sitRevista") ? query.get("sitRevista") : null
  );
  const [tipoDeRelacion, setTipoDeRelacion] = useState(
    query.get("idTipoAfiliacion") ? query.get("idTipoAfiliacion") : null
  );
  const [cuitEmpresa, setCuitEmpresa] = useState(
    query.get("cuitEmpresa") ? query.get("cuitEmpresa") : null
  );
  const [sexo, setSexo] = useState (
    query.get("sexo") ? query.get("sexo") : null
  );

  const [discapacidad, setDiscapacidad] = useState(
    query.get("discapacidad") ? true : false
  );

  const [errorCuitEmpresa, setErrorCuitEmpresa] = useState("");

  const { items: configCategorias } = useSelector(
    (state) => state.configuracionesCategoria
  );

  useEffect(() => {
    let aux = [];
    // eslint-disable-next-line
    allLocalidades.map((e) => {
      // eslint-disable-next-line
      provinciasSelected.map((p) => {
        // eslint-disable-next-line
        if (p !== 1 && e.id_provincia == p) {
          aux.push(e);
        }
      });
    });
    setLocalidades(aux);
    // eslint-disable-next-line
  }, [provinciasSelected]);

  useEffect(() => {
    if (categoria != null) {
      dispatch(traerConfiguracionPorCategoria(categoria));
    }
  }, [dispatch, categoria]);

  useEffect(() => {
    if(props.idAreaUsuario === areas.Seccional){
      setseccionalesSelected([...seccionalesSelected, props.idSeccionalUsuario]);
    }
  }, []);

  const handleSetSeccionalesSeleccionadas = (value, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setseccionalesSelected(seccionalesSelected.filter((e) => e != value));
    } else {
      setseccionalesSelected([...seccionalesSelected, value]);
    }
  };

  const handleSetProvinciasSeleccionadas = (value, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setprovinciasSelected(provinciasSelected.filter((e) => e != value));
    } else {
      setprovinciasSelected([...provinciasSelected, value]);
    }
  };

  const handleSetLocalidadesSeleccionadas = (value, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setlocalidadesSelected(localidadesSelected.filter((e) => e != value));
    } else {
      setlocalidadesSelected([...localidadesSelected, value]);
    }
  };

  const handleChangeParentesco = (e) => {
    //Se deberia hacer como las localidades, pero por el momento solo es para titulares
    if (e.target.checked) {
      setParentescos(true);
    } else {
      setParentescos(false);
    }
  };

  const handleSetCategoria = (event, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setCategoria(null);
    } else {
      setCategoria(event.target.value);
    }
  };

  const handleSetSexo = (event, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setSexo(null);
    } else {
      setSexo(event.target.value);
    }
  };

  const handleChangeDiscapacidad= (e) => {
    //Se deberia hacer como las localidades, pero por el momento solo es para titulares
    if (e.target.checked) {
      setDiscapacidad(true);
    } else {
      setDiscapacidad(false);
    }
  };

  const handleSetMotivosBaja = (event, remove = false) => {
    if (remove) {
      setMotivoBaja(null);
    } else {
      setMotivoBaja(event.target.value);
    }
  };

  const handleSetTipoDeRelacion = (event, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setTipoDeRelacion(null);
    } else {
      setTipoDeRelacion(event.target.value);
    }
  };

  const handleSetCuitEmpresa = (event, remove = false) => {
    if (remove) {
      // eslint-disable-next-line
      setCuitEmpresa(null);
    } else {
      setCuitEmpresa(event.target.value);
    }
  };

  const cuitEmpresaValidacion = (cuit) => {
    if (isNaN(cuit)) {
      setErrorCuitEmpresa("Número no valido");
    } else if (cuit.length === 0) {
      setErrorCuitEmpresa("");
    } else if (cuit.length !== 11) {
      setErrorCuitEmpresa("Verifique su CUIT");
    } else {
      setErrorCuitEmpresa("");
    }
  };

  const handleClose = () => {
    setAbrirModal(false);
  };

  const handleSubmitFiltros = () => {
    if (seccionalesSelected.length > 0) {
      query.set("seccionales", seccionalesSelected.join(","));
    } else {
      query.delete("seccionales");
    }
    if (provinciasSelected.length > 0) {
      query.set("provincias", provinciasSelected.join(","));
    } else {
      query.delete("provincias");
    }
    if (localidadesSelected.length > 0) {
      query.set("localidades", localidadesSelected.join(","));
    } else {
      query.delete("localidades");
    }
    if (edadDesde !== null && edadHasta !== null) {
      query.set("fecNacDesde", moment(edadDesde).format("YYYY-MM-DD"));
      query.set("fecNacHasta", moment(edadHasta).format("YYYY-MM-DD"));
    }
    if (fechaDesde !== null && fechaHasta !== null) {
      query.set("fecAltaDesde", moment(fechaDesde).format("YYYY-MM-DD"));
      query.set("fecAltaHasta", moment(fechaHasta).format("YYYY-MM-DD"));
    }
    if (fechaBajaDesde !== null && fechaBajaHasta !== null) {
      query.set("fecBajaDesde", moment(fechaBajaDesde).format("YYYY-MM-DD"));
      query.set("fecBajaHasta", moment(fechaBajaHasta).format("YYYY-MM-DD"));
    }
    if (parentescos) {
      query.set("parentescos", 0);
    } else {
      query.delete("parentescos");
    }
    if (categoria !== null && categoria > 0) {
      query.set("categoria", categoria);
    } else {
      query.delete("categoria");
    }
    if (motivoDeBaja !== null) {
      query.set("motivoBaja", motivoDeBaja);
    } else {
      query.delete("motivoBaja");
    }
    if (tipoDeRelacion !== null && tipoDeRelacion > 0) {
      query.set("tipoAfiliacion", tipoDeRelacion);
    } else {
      query.delete("tipoAfiliacion");
    }
    if (cuitEmpresa !== null && cuitEmpresa.length > 0) {
      query.set("cuitEmpresa", cuitEmpresa);
    } else {
      query.delete("cuitEmpresa");
    }
    if (sexo !== null) {
      query.set("sexo", sexo);
    } else {
      query.delete("sexo");
    }

    if (parentescos) {
      query.set("discapacidad", 0);
    } else {
      query.delete("discapacidad");
    }

    history.push(`?${query.toString()}`);
  };

  const handleCleanFilters = () => {
    history.push("/Consultas");
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={abrirModal}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Filtros
            </Typography>
            <Button
              // variant="contained"
              // color="primary"
              style={{ color: "#fff", marginRight: "1rem" }}
              onClick={handleCleanFilters}
            >
              Limpiar Filtros
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmitFiltros}
            >
              Aplicar Filtros
            </Button>
          </Toolbar>
        </AppBar>
        <Grid container style={{ padding: "1rem" }}>
          <Grid item xs={12}>
            <Typography variant="h5">Parentesco</Typography>
            <Grid container alignItems="center">
              {/* <Grid item xs={12}> */}
              <Switch
                checked={parentescos}
                onChange={handleChangeParentesco}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.checked,
                  track: classes.track,
                }}
              />
              <Typography className={classes.TypographyRoot}>
                Solo Titulares
              </Typography>
              {/* </Grid> */}
            </Grid>
            <Typography variant="h5">Sexo</Typography>
            <Grid container>
              <Grid xs={12} sm={4}>
                <Select
                  value={sexo}
                  onChange={(e)=>{
                    handleSetSexo(e)
                  }}
                  label="Sexo"
                  name="sexo"
                  style={{ marginTop: "2rem" }}
                  fullWidth
                >
                  <MenuItem value={SEXO.FEMENINO}>FEMENINO</MenuItem>
                  <MenuItem value={SEXO.MASCULINO}>MASCULINO</MenuItem>
                  <MenuItem value={SEXO.NO_INFORMADO}>NO INFORMADO</MenuItem>
                  <MenuItem value={SEXO.NO_BINARIO}>NO BINARIO</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Typography variant="h5" style={{ marginTop: "1rem" }}>
              Rango etario
            </Typography>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha de nacimiento desde"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    maxDate={new Date()} //maxDate
                    fullWidth
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(edadDesde).isValid() ? moment(edadDesde) : null
                    }
                    onChange={(date) => {
                      setEdadDesde(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha de nacimiento hasta"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    maxDate={new Date()} //maxDate
                    fullWidth
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(edadHasta).isValid() ? moment(edadHasta) : null
                    }
                    onChange={(date) => {
                      setEdadHasta(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            <Typography variant="h5" style={{ marginTop: "1rem" }}>
              Fechas de alta
            </Typography>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha de alta desde"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    maxDate={new Date()} //maxDate
                    fullWidth
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(fechaDesde).isValid() ? moment(fechaDesde) : null
                    }
                    onChange={(date) => {
                      setFechaDesde(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha de alta hasta"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    maxDate={new Date()} //maxDate
                    fullWidth
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(fechaHasta).isValid() ? moment(fechaHasta) : null
                    }
                    onChange={(date) => {
                      setFechaHasta(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            <Typography variant="h5" style={{ marginTop: "1rem" }}>
              Fechas de Baja
            </Typography>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha de baja desde"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    maxDate={new Date()} //maxDate
                    fullWidth
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(fechaBajaDesde).isValid() ? moment(fechaBajaDesde) : null
                    }
                    onChange={(date) => {
                      setFechaBajaDesde(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="Fecha de baja hasta"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    maxDate={new Date()} //maxDate
                    fullWidth
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(fechaBajaHasta).isValid() ? moment(fechaBajaHasta) : null
                    }
                    onChange={(date) => {
                      setFechaBajaHasta(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} sm={4}>
                <Typography variant="h5" style={{ marginTop: "1rem" }}>
                  Motivos Baja
                </Typography>
                <Grid container>
                  <Select
                    value={motivoDeBaja}
                    onChange={(e) => {
                      handleSetMotivosBaja(e);
                    }}
                    label="Motivos Baja"
                    name="motivoBaja"
                    style={{ marginTop: "2rem" }}
                    fullWidth
                  >
                    <MenuItem value="" selected>
                      <em>Seleccione</em>
                    </MenuItem>
                    <MenuItem value={0}>TODOS</MenuItem>
                    {props.motivoBaja &&
                      props.motivoBaja.length > 0 &&
                      props.motivoBaja.map((motivosBaja, index) => {
                        return (
                          <MenuItem value={motivosBaja.id} key={index}>
                            {motivosBaja.descripcion}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={4}>
                  <Typography variant="h5" style={{ marginTop: "1rem" }}>
                    Categoria
                  </Typography>
                  <Grid container>
                    <Select
                      value={categoria}
                      onChange={(e) => {
                        handleSetCategoria(e);
                      }}
                      label="Categoria"
                      name="categoria"
                      style={{ marginTop: "2rem" }}
                      fullWidth
                    >
                      <MenuItem value="" selected>
                        <em>Seleccione</em>
                      </MenuItem>
                      {props.categorias &&
                        props.categorias.length > 0 &&
                        props.categorias.map((categoria, index) => {
                          return (
                            <MenuItem value={categoria.id_sr} key={index}>
                              {categoria.descripcion_sr}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Grid>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={12} sm={4}>
                  <Typography variant="h5" style={{ marginTop: "1rem" }}>
                    Tipo de Relación
                  </Typography>
                  <Grid container>
                    <Select
                      value={tipoDeRelacion}
                      onChange={(e) => {
                        handleSetTipoDeRelacion(e);
                      }}
                      label="Tipo de Relación"
                      name="tipoDeRelacion"
                      style={{ marginTop: "2rem" }}
                      fullWidth
                    >
                      <MenuItem value="">
                        <em>Seleccione</em>
                      </MenuItem>
                      {configCategorias &&
                        configCategorias.length > 0 &&
                        configCategorias.map((tipo) => {
                          return (
                            tipo.marcado === true && (
                              <MenuItem
                                value={tipo.idTipoAfiliacion}
                                key={tipo.idTipoAfiliacion}
                              >
                                {tipo.tipoAfiliacion.descripcion_afiliacion}
                              </MenuItem>
                            )
                          );
                        })}
                    </Select>
                  </Grid>
                </Grid>
                <Grid item xs={1} />
              </Grid>

              <Typography
                variant="h5"
                style={{ marginBottom: "0px", marginTop: "1.5rem" }}
              >
                Empresa CUIT
              </Typography>
              <Grid container>
                <Grid item xs={4}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="CUIT Empresa"
                    name="cuitEmpresa"
                    value={cuitEmpresa || ""}
                    error={errorCuitEmpresa && errorCuitEmpresa.length > 0}
                    helperText={errorCuitEmpresa}
                    autoComplete="off"
                    onChange={(e) => {
                      handleSetCuitEmpresa(e);
                      cuitEmpresaValidacion(e.target.value);
                    }}
                    onBlur={(e) => {
                      cuitEmpresaValidacion(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={8} />
              </Grid>

              <Typography variant="h5">Discapacidad</Typography>
              <Grid container alignItems="center">
                <Switch
                  checked={discapacidad}
                  onChange={handleChangeDiscapacidad}
                  classes={{
                    switchBase: classes.switchBase,
                    checked: classes.checked,
                    track: classes.track,
                  }}
                />
              </Grid>

              <Typography
                variant="h5"
                style={{ marginBottom: "1rem", marginTop: "1rem" }}
              >
                Seccional
              </Typography>
              <Grid container>
                {seccionales.map((seccional) => (
                  <Grid item xs={12} sm={3} key={seccional.id_seccional}>
                    <ItemFilters
                      value={seccional.id_seccional}
                      label={seccional.descripcion_seccional}
                      setItem={handleSetSeccionalesSeleccionadas}
                      selected={seccionalesSelected}
                      isDisabled={props.idAreaUsuario === areas.Seccional}
                    />
                  </Grid>
                ))}
              </Grid>

              <Typography
                variant="h5"
                style={{ marginBottom: "1rem", marginTop: "1rem" }}
              >
                Provincias
              </Typography>
              <Grid container>
                {provincias.map((provincia) => (
                  <Grid item xs={12} sm={3} key={provincia.id_provincia}>
                    <ItemFilters
                      value={provincia.id_provincia}
                      label={provincia.descripcion_provincia}
                      setItem={handleSetProvinciasSeleccionadas}
                      selected={provinciasSelected}
                    />
                  </Grid>
                ))}
              </Grid>

              <Typography
                variant="h5"
                style={{ marginBottom: "1rem", marginTop: "1rem" }}
              >
                Localidades
              </Typography>
              <Grid container>
                {localidades.length === 0 && (
                  <Typography variant="body1">
                    Seleccione una provincia...
                  </Typography>
                )}
                {localidades.map((localidad) => (
                  <Grid item xs={12} sm={3} key={localidad.id_localidad}>
                    <ItemFilters
                      value={localidad.id_localidad}
                      label={localidad.descripcion_localidad}
                      setItem={handleSetLocalidadesSeleccionadas}
                      selected={localidadesSelected}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
}
